import { useContext } from "react";
import ForexListingDataContext from "../Contexts/ForexListingDataContext";
import { ListingReducerType } from "../store/forexListingReducer";

export const useGlobalSelector = (cb: any): ListingReducerType => {
  const data = useContext(ForexListingDataContext);
  return cb(data);
};
